const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || `${window.location.protocol}//${window.location.hostname}:8000/api`;

export const apiFetch = (path, opts = {}) =>
  fetch(`${BACKEND_URL}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(opts.headers || {})
    },
    ...opts,
  }).then(async (res) => {
    if (!res.ok) {
      let err;
      try { err = await res.json(); } catch { err = { message: res.statusText }; }
      throw err;
    }
    if (res.status === 204) return null;
    return res.json();
  }); 